import script from "./BatchEditSku.vue.vue?vue&type=script&lang=ts&setup=true"
export * from "./BatchEditSku.vue.vue?vue&type=script&lang=ts&setup=true"

import "./BatchEditSku.vue.vue?vue&type=style&index=0&id=3378b627&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3378b627"]])

export default __exports__